import { Button, FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { initialsFromTitle } from "./chatDisplay";
import type { typeInvitationRow } from "./messagesListState";
import {
  INVITATION_ACCEPT_LABEL,
  INVITATION_DECLINE_LABEL,
} from "./standaloneChatCopy";

export function PendingInvitationRow({
  row,
  onSelect,
  onAccept,
  onDecline,
  testId,
}: {
  row: typeInvitationRow;
  onSelect: () => void;
  onAccept: () => void;
  onDecline: () => void;
  testId?: string;
}): ReactNode {
  return (
    <div className="flex w-full items-center gap-2 rounded-md bg-surface px-2 py-2">
      <button
        type="button"
        onClick={onSelect}
        data-testid={testId}
        className={`flex min-h-touch-target flex-1 items-center gap-3 rounded-md text-left ${FOCUS_RING}`}
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-solid text-caption text-on-primary">
          {initialsFromTitle(row.title)}
        </span>
        <p className="text-body text-ink">
          {row.invitedByDisplayName} invited you to {row.title}
        </p>
      </button>
      <Button
        variant="secondary"
        size="sm"
        data-testid="invitation-decline"
        onClick={onDecline}
      >
        {INVITATION_DECLINE_LABEL}
      </Button>
      <Button
        variant="primary"
        size="sm"
        data-testid="invitation-accept"
        onClick={onAccept}
      >
        {INVITATION_ACCEPT_LABEL}
      </Button>
    </div>
  );
}
